/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-len */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/zh-tw';

import { getDateLocale } from '@src/utils/time';
import resources from './locales';

i18n
	.use(initReactI18next)
	.init({
		resources,
		lng: 'zh-TW',
		fallbackLng: 'en',
		ns: ['common', 'hr', 'share', 'training'],
		defaultNS: ['common'],
		debug: false && process.env.NODE_ENV === 'development',
	});

// 非預設語言字典不進初始 bundle，切換時才動態載入 (zh-TW 已 eager)
// key 用 i18next format 後的代碼，對齊 toResolveHierarchy 查 bundle 的形式
const LAZY_LOCALES = {
	en: () => import('./locales/en.json'),
};

// 語言代碼 → lazy 字典 key: en / en-US / en-GB → en; 其餘 (zh-TW 等)不需載入
const toLazyLocale = lng => {
	const lower = (lng || '').toLowerCase();
	if (lower.split('-')[0] === 'en') return 'en';
	return null;
};

const loadingPromises = {};
const loadLocale = locale => {
	if (i18n.hasResourceBundle(locale, 'common')) return Promise.resolve();
	if (!loadingPromises[locale]) {
		loadingPromises[locale] = LAZY_LOCALES[locale]().then(mod => {
			const dict = mod['default'] || mod;
			Object.keys(dict).forEach(ns => {
				i18n.addResourceBundle(locale, ns, dict[ns], true, true);
			});
		}, err => {
			// chunk 載入失敗時重設，讓下次切換能重試，不要快取 rejected promise
			loadingPromises[locale] = null;
			throw err;
		});
	}
	return loadingPromises[locale];
};

// 切語言前先確保該語言字典已載入
export const ensureLanguage = lng => {
	const locale = toLazyLocale(lng);
	return locale ? loadLocale(locale) : Promise.resolve();
};

// 包一層 changeLanguage:先補載字典再切，避免 fallback 到 zh-TW 的閃爍
let languageRequest = 0;
export const changeAppLanguage = lng => {
	// eslint-disable-next-line no-plusplus
	const request = ++languageRequest;
	const locale = lng.toLowerCase().startsWith('zh') ? 'zh-TW' : 'en';
	return ensureLanguage(locale).then(() => {
		if (request === languageRequest) return i18n.changeLanguage(locale);
		return undefined;
	});
};

// Initial rendering is deterministic for SSR; useAppLanguage applies the client policy.
if (typeof window !== 'undefined') {
	moment.locale(getDateLocale(i18n.language));
	i18n.on('languageChanged', lng => {
		moment.locale(getDateLocale(lng));
		document.documentElement.lang = lng;
	});
}

export default i18n;
